import React from "react";

const TeamMemberIcon = ({
  className = "",
  viewBox = "0 0 120 120",
  fill = "currentColor",
  stroke = "currentColor",
  strokeWidth = "2",
  ...props
}) => (
  <svg
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <circle cx="60" cy="60" r="60" fill={fill} className="text-primary/30" />
    <path
      d="M60 35C48.954 35 40 43.954 40 55C40 66.046 48.954 75 60 75C71.046 75 80 66.046 80 55C80 43.954 71.046 35 60 35ZM60 82.5C42.327 82.5 28 96.827 28 114.5H92C92 96.827 77.673 82.5 60 82.5Z"
      fill={fill}
      className="text-primary"
    />
  </svg>
);

export default TeamMemberIcon;
